import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private themeWrapper = document.documentElement;

  constructor() {}

  setBlendTheme() {
    this.themeWrapper.style.setProperty('--primary', '#fff');
    this.themeWrapper.style.setProperty('--primary-light', '#fff');
    this.themeWrapper.style.setProperty('--toolbar', '#fff');
    this.themeWrapper.style.setProperty('--success', '#00aa00');
    this.themeWrapper.style.setProperty('--success-light', '#9dd29c');
    this.themeWrapper.style.setProperty('--darker', '#383838');
  }
  setGlobalTheme() {
    this.themeWrapper.style.setProperty('--primary', '#fcb040');
    this.themeWrapper.style.setProperty('--primary-light', '#fcc454');
    this.themeWrapper.style.setProperty('--toolbar', '#fff');
    this.themeWrapper.style.setProperty('--success', '#00aa00');
    this.themeWrapper.style.setProperty('--success-light', '#9dd29c');
    this.themeWrapper.style.setProperty('--darker', '#383838');
    setTimeout( () => {
      document.getElementById("logoToolbar").style.display = "block";
      document.getElementById("labelToolbar").innerHTML = "";
    }, 300);
  }

  setElevaTheme() {
    this.themeWrapper.style.setProperty('--primary', '#00806f');
    this.themeWrapper.style.setProperty('--primary-light', '#50B6A3');
    this.themeWrapper.style.setProperty('--toolbar', '#00806f');
    this.themeWrapper.style.setProperty('--success', '#00aa00');
    this.themeWrapper.style.setProperty('--success-light', '#9dd29c');
    this.themeWrapper.style.setProperty('--darker', '#383838');
    setTimeout( () => {
      document.getElementById("logoToolbar").style.display = "none";
      document.getElementById("labelToolbar").innerHTML = "Questionário POA";
      document.getElementById("labelToolbar2").innerHTML = "Pesquisa de opinião do aluno";
    }, 300);
  }
}
